import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Section from '../../components/Section';
import { Box, Typography, Button } from '@mui/material';
import { fadeIn } from './helpers';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import MarkdownText from '../../components/MarkdownText';

/**
 * VideoAsk Block Component
 *
 * Displays a call-to-action block that links to the VideoAsk page.
 * This component is designed to be inserted before the "Lämna inte kärleken åt slumpen" section.
 */
const VideoAskBlock = ({ duration }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    navigate('/introduce-yourself');
  };

  return (
    <Section
      small
      highlight
      sx={{
        textAlign: 'center',
        em: { color: 'white', fontWeight: 'bold' },
        mx: 2,
        mb: 2,
        borderRadius: '16px !important',
        backgroundColor: theme => theme.palette.background.paper,
        ...duration > 0 && {
          opacity: 0,
          animation: `${fadeIn} 500ms forwards linear`,
          animationDelay: `${duration + 1}s`,
        },
      }}
    >
      <Typography component="h2" variant="h2">
        {t('videoask_block.title', 'Berätta vem du är – med dina egna ord')}
      </Typography>
      <MarkdownText>
        {t('videoask_block.description', 'Vi vill gärna få en mer personlig bild av dig. Titta på en kort video där jag ställer några frågor om dig och vad du söker – så kan vi känna in vem du är bortom profilen.')}
      </MarkdownText>
      <Box
        onClick={handleClick}
        sx={{
          width: '100%',
          mt: 3,
          mb: 2,
          borderRadius: 2,
          overflow: 'hidden',
          cursor: 'pointer',
          transition: 'transform 0.2s, opacity 0.2s',
          '&:hover': {
            transform: 'scale(1.02)',
            opacity: 0.9,
          },
        }}
      >
        <Box
          component="img"
          src="https://media.videoask.com/transcoded/cf229bd7-1102-484b-87c7-b81eedd08246/thumbnails/videoask_play.gif"
          alt="VideoAsk preview"
          sx={{
            width: '100%',
            height: 'auto',
            display: 'block',
          }}
        />
      </Box>
      <Box sx={{ pt: 2 }}>
        <Button
          type="submit"
          size="large"
          variant="contained"
          sx={{ mt: 1, minWidth: 320 }}
          onClick={handleClick}
          startIcon={<PlayArrowIcon />}
        >
          {t('videoask_block.button', 'Spela in din video idag')}
        </Button>
      </Box>
    </Section>
  );
};

export default VideoAskBlock;
